module.exports = __webpack_public_path__ + "9f472270dbb17c9763d8b64070c50cc5.png";